import { createTheme } from "@mui/material/styles";
import { PaletteMode } from "@mui/material";

const PRIMARY_BLUE = "#3f9fff";
const HOVER_LIGHT = "rgba(255,231,219,0.7)";
const HOVER_DARK = "rgba(255,255,255,0.08)";

export const getHoverColor = (mode: PaletteMode): string =>
  mode === "light" ? HOVER_LIGHT : HOVER_DARK;

export const createAppTheme = (mode: PaletteMode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: PRIMARY_BLUE },
      background: {
        default: mode === "light" ? "#f2f3f7" : "#111318",
        paper: mode === "light" ? "#ffffff" : "#1c1e26",
      },
    },
    breakpoints: {
      values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              fontFamily: "Arial",
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: PRIMARY_BLUE,
                borderWidth: "2px",
              },
              "&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
                borderColor: PRIMARY_BLUE,
                borderWidth: "1px",
              },
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none" },
        },
      },
    },
  });

export default createAppTheme("light");
